// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Request_dialogContent__7dNd6 {
  background: linear-gradient(
    91deg,
    rgba(90, 155, 216, 0.1) 23.22%,
    rgba(90, 155, 216, 0) 99.28%
  );
  padding: 20px;
  /* max-width: 800px; */
}

.Request_sectionBox__H6MfH {
  background-color: #ffffff;
  padding: 15px;
  margin-bottom: 20px;
  border: 1px solid #e0e0e0;
  border-radius: 0.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}
.Request_sectionBoxReq__oAmvR {
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  padding: 15px;
  margin-bottom: 20px;
  border: 1px solid #e0e0e0;
  border-radius: 0.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.Request_contentContainerReq__A3Ep4 {
  display: flex;
  flex-direction: row;
  gap: 16px;
}

.Request_detailsContainerReq__O22jA {
  flex: 2 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.Request_imageContainer__g7fKm {
  flex: 1 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.Request_avatarImage__vOc-S {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  object-fit: cover;
}

.Request_sectionTitle__02l\\+K {
  font-weight: 600;
  margin-bottom: 10px;
  color: #555;
}

.Request_sectionTitleRes__tg13h {
  font-weight: 600;
  margin-bottom: 10px;
  color: #555;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.Request_addResourceContainer__80yKM {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.Request_editButton__D5lKH {
  margin-left: 8px;
}

.Request_detailRow__AmInQ {
  display: flex;
  align-items: center;
  gap: 8px;
}

.Request_headingContainer__94Oto {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.Request_modalTitle__Xl9Fs {
  font-weight: 600;
}

.Request_btnse__0lTue {
  margin-right: 10px;
}

.Request_btnsv__t-jLf {
  margin-right: 10px;
}

.Request_closeButton__Gl3Gx {
  color: #5A9BD8;
  padding: 5px;
  border: 1px #5A9BD8 solid;
}

.Request_detailsContainer__sHIe3 {
  display: grid;
  grid-template-columns: 10rem 1fr;
  gap: 10px;
  margin-top: 10px;
}

.Request_label__kBcCq {
  color: #555;
}

.Request_value__-bp4Y {
  color: #333;
}

.Request_requesterLabel__0aKYV {
  margin-bottom: 5px;
  padding-left: 6px;
}
.Request_requesterIDLabel__OnQxH {
  margin-bottom: 10px;
  padding-left: 6px;
}

.Request_formItem__Cefze {
  margin-top: 1rem;
}

.Request_formLabel__Vfs4q {
  font-weight: 600;
  margin-bottom: 8px;
}

.Request_formInput__XK8di {
  margin-top: 0.3rem;
}

.Request_validation__eZ9cw {
  color: red;
}

.Request_buttonContainer__yICA4 {
  margin-top: 2rem;
  margin-bottom: 1rem;
  display: flex;
  justify-content: center;
  gap: 1rem;
}

.Request_button__eQe\\+M {
  flex: 1 1; 
  max-width: 200px; 
  min-width: 150px; 
}

.Request_submitButton__tIWyM {
  width: 10rem;
}`, "",{"version":3,"sources":["webpack://./src/Components/Requests/Request.module.css"],"names":[],"mappings":"AAAA;EACE;;;;GAIC;EACD,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,wCAAwC;AAC1C;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd","sourcesContent":[".dialogContent {\r\n  background: linear-gradient(\r\n    91deg,\r\n    rgba(90, 155, 216, 0.1) 23.22%,\r\n    rgba(90, 155, 216, 0) 99.28%\r\n  );\r\n  padding: 20px;\r\n  /* max-width: 800px; */\r\n}\r\n\r\n.sectionBox {\r\n  background-color: #ffffff;\r\n  padding: 15px;\r\n  margin-bottom: 20px;\r\n  border: 1px solid #e0e0e0;\r\n  border-radius: 0.5rem;\r\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\r\n}\r\n.sectionBoxReq {\r\n  display: flex;\r\n  flex-direction: column;\r\n  background-color: #ffffff;\r\n  padding: 15px;\r\n  margin-bottom: 20px;\r\n  border: 1px solid #e0e0e0;\r\n  border-radius: 0.5rem;\r\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.contentContainerReq {\r\n  display: flex;\r\n  flex-direction: row;\r\n  gap: 16px;\r\n}\r\n\r\n.detailsContainerReq {\r\n  flex: 2;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n}\r\n\r\n.imageContainer {\r\n  flex: 1;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.avatarImage {\r\n  width: 100px;\r\n  height: 100px;\r\n  border-radius: 50%;\r\n  object-fit: cover;\r\n}\r\n\r\n.sectionTitle {\r\n  font-weight: 600;\r\n  margin-bottom: 10px;\r\n  color: #555;\r\n}\r\n\r\n.sectionTitleRes {\r\n  font-weight: 600;\r\n  margin-bottom: 10px;\r\n  color: #555;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.addResourceContainer {\r\n  display: flex;\r\n  justify-content: center;\r\n  margin-top: 20px;\r\n}\r\n\r\n.editButton {\r\n  margin-left: 8px;\r\n}\r\n\r\n.detailRow {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.headingContainer {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.modalTitle {\r\n  font-weight: 600;\r\n}\r\n\r\n.btnse {\r\n  margin-right: 10px;\r\n}\r\n\r\n.btnsv {\r\n  margin-right: 10px;\r\n}\r\n\r\n.closeButton {\r\n  color: #5A9BD8;\r\n  padding: 5px;\r\n  border: 1px #5A9BD8 solid;\r\n}\r\n\r\n.detailsContainer {\r\n  display: grid;\r\n  grid-template-columns: 10rem 1fr;\r\n  gap: 10px;\r\n  margin-top: 10px;\r\n}\r\n\r\n.label {\r\n  color: #555;\r\n}\r\n\r\n.value {\r\n  color: #333;\r\n}\r\n\r\n.requesterLabel {\r\n  margin-bottom: 5px;\r\n  padding-left: 6px;\r\n}\r\n.requesterIDLabel {\r\n  margin-bottom: 10px;\r\n  padding-left: 6px;\r\n}\r\n\r\n.formItem {\r\n  margin-top: 1rem;\r\n}\r\n\r\n.formLabel {\r\n  font-weight: 600;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.formInput {\r\n  margin-top: 0.3rem;\r\n}\r\n\r\n.validation {\r\n  color: red;\r\n}\r\n\r\n.buttonContainer {\r\n  margin-top: 2rem;\r\n  margin-bottom: 1rem;\r\n  display: flex;\r\n  justify-content: center;\r\n  gap: 1rem;\r\n}\r\n\r\n.button {\r\n  flex: 1; \r\n  max-width: 200px; \r\n  min-width: 150px; \r\n}\r\n\r\n.submitButton {\r\n  width: 10rem;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dialogContent": `Request_dialogContent__7dNd6`,
	"sectionBox": `Request_sectionBox__H6MfH`,
	"sectionBoxReq": `Request_sectionBoxReq__oAmvR`,
	"contentContainerReq": `Request_contentContainerReq__A3Ep4`,
	"detailsContainerReq": `Request_detailsContainerReq__O22jA`,
	"imageContainer": `Request_imageContainer__g7fKm`,
	"avatarImage": `Request_avatarImage__vOc-S`,
	"sectionTitle": `Request_sectionTitle__02l+K`,
	"sectionTitleRes": `Request_sectionTitleRes__tg13h`,
	"addResourceContainer": `Request_addResourceContainer__80yKM`,
	"editButton": `Request_editButton__D5lKH`,
	"detailRow": `Request_detailRow__AmInQ`,
	"headingContainer": `Request_headingContainer__94Oto`,
	"modalTitle": `Request_modalTitle__Xl9Fs`,
	"btnse": `Request_btnse__0lTue`,
	"btnsv": `Request_btnsv__t-jLf`,
	"closeButton": `Request_closeButton__Gl3Gx`,
	"detailsContainer": `Request_detailsContainer__sHIe3`,
	"label": `Request_label__kBcCq`,
	"value": `Request_value__-bp4Y`,
	"requesterLabel": `Request_requesterLabel__0aKYV`,
	"requesterIDLabel": `Request_requesterIDLabel__OnQxH`,
	"formItem": `Request_formItem__Cefze`,
	"formLabel": `Request_formLabel__Vfs4q`,
	"formInput": `Request_formInput__XK8di`,
	"validation": `Request_validation__eZ9cw`,
	"buttonContainer": `Request_buttonContainer__yICA4`,
	"button": `Request_button__eQe+M`,
	"submitButton": `Request_submitButton__tIWyM`
};
export default ___CSS_LOADER_EXPORT___;
